export default __webpack_public_path__ + "images/Indian.dcbef7.jpg";